import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  button: {
    fontWeight: 600,
    fontSize: 16,
    textTransform: 'unset',
    padding: '12px 24px',
    borderRadius: theme.borderRadius.md,
    boxShadow: 'none',

    '&.MuiButton-startIcon': {
      ...dFlex(),
    },

    '&.MuiButton-sizeLarge': {
      height: 44,
    },

    '&.MuiButton-sizeMedium': {
      height: 40,
    },

    '&.MuiButton-sizeSmall': {
      height: 32,
      padding: '6px 16px',
    },

    '&.MuiButton-contained': {
      background: theme.palette.custom.buttons.primary,
      color: theme.palette.custom.buttons.text,

      '&:hover': {
        background: theme.palette.custom.buttons.primaryHover,
        color: theme.palette.custom.buttons.text,
      },

      '&:focus-visible': {
        background: theme.palette.custom.buttons.primaryHover,
        color: theme.palette.custom.buttons.text,
      },

      '&:active': {
        background: theme.palette.custom.buttons.primary,
        color: theme.palette.custom.buttons.text,
      },

      '&:disabled': {
        opacity: 0.38,
      },
    },

    '&.MuiButton-secondary': {
      background: theme.palette.custom.buttons.secondary,
      color: theme.palette.custom.buttons.text,

      '&:hover': {
        background: theme.palette.custom.buttons.secondaryHover,
        color: theme.palette.custom.buttons.text,
      },

      '&:focus-visible': {
        background: theme.palette.custom.buttons.secondaryHover,
        color: theme.palette.custom.buttons.text,
      },

      '&:active': {
        background: theme.palette.custom.buttons.secondary,
        color: theme.palette.custom.buttons.text,
      },

      '&:disabled': {
        opacity: 0.38,
      },

      '&.Mui-disabled': {
        opacity: 0.38,
      },
    },

    '&.MuiButton-outline': {
      background: 'transparent',
      color: theme.palette.custom.text.dark,
      border: `1px solid ${theme.palette.custom.border.secondary}`,
      fontSize: 14,

      '&:hover': {
        background: theme.palette.custom.background.medium,
        color: theme.palette.custom.text.dark,
      },

      '&:focus-visible': {
        background: theme.palette.custom.background.medium,
        color: theme.palette.custom.text.dark,
      },

      '&:disabled': {
        opacity: 0.38,
      },
    },

    '&.MuiButton-text': {
      padding: '4px',
      background: 'transparent',
      color: theme.palette.custom.buttons.dark,

      '&:hover': {
        color: theme.palette.custom.buttons.darkHover,
      },

      '&:focus-visible': {
        color: theme.palette.custom.buttons.dark,
      },

      '&:active': {
        color: theme.palette.custom.buttons.darkHover,
      },

      '&:disabled': {
        opacity: 0.38,
      },
    },
  },
  loading: {
    '& .MuiButton-icon': {
      display: 'none',
    },

    '&.MuiButton-contained': {
      background: theme.palette.custom.buttons.primary,
      color: theme.palette.custom.buttons.text,
      cursor: 'default',

      '&:disabled': {
        opacity: 1,
      },
    },

    '&.MuiButton-secondary': {
      background: theme.palette.custom.buttons.secondary,
      color: theme.palette.custom.buttons.text,
      cursor: 'default',

      '&:disabled': {
        opacity: 1,
      },
    },
  },
  loader: {
    width: 18,
    color: theme.palette.custom.buttons.text,
  },
  iconLeft: {
    ...dFlex(),
    marginRight: 4,

    '& img': {
      width: 20,
      height: 20,
    },
  },
  iconRight: {
    ...dFlex(),
    marginLeft: 4,

    '& img': {
      width: 20,
      height: 20,
    },
  },
  content: {
    ...dFlex('initial', 'initial'),
  },
  children: {
    ...dFlex(),
    textWrap: 'nowrap',
  },
}));

export default useStyles;
